'use strict';

const TextBoxFieldView = require('components/ui/field_text_box/js/view');
const TextBoxFieldViewProto = TextBoxFieldView.prototype;
const setCvvState = function(view) {
    const model = view.model;
    model.setValue(view.$input.val(), {
        validate: false,
        silent: true,
    });
    if (!model.validate()) {
        view.$input.blur();
        view.model.set('validationStatus', 'valid');
    } else {
        view.model.set('validationStatus', 'validating');
    }
};

const toggleHelp = (view, toggle) => {
    view.$helpContainer.toggleClass(view.getToggleClass(), !toggle);
    if (view.$slideCvvContainer) {
        view.$slideCvvContainer.toggleClass('od-show-cvv-help', toggle);
    } else {
        view.$fieldContainer.toggleClass('od-cvv-container-form', toggle);
    }
};

module.exports = TextBoxFieldView.extend({
    events: Odigeo._.extend({}, TextBoxFieldViewProto.events, {
        'input input': 'onInput',
        'blur input': 'onBlur',
    }),

    initialize(options) {
        this.$slideCvvContainer = Odigeo._.get(options, 'options.$cvvSlideContainer');
        this.setInlineKeys(this.$slideCvvContainer, options);
        TextBoxFieldViewProto.initialize.call(this, options);
        this.$fieldContainer = this.$el.find('.cvv_field_container');
        this.$helpContainer = this.$el.find('.cvv_help_container');
    },

    getToggleClass() {
        return this.$slideCvvContainer ? 'open' : 'odf-hidden';
    },

    setInlineKeys(inline, options) {
        if (inline) {
            const keys = Odigeo._.get(options, 'resources.keys') || {};
            keys.label = keys.labelInline;
            keys.validationError = keys.validationErrorInline;
            keys.validationMandatory = keys.validationMandatoryInline;
        }
    },

    onBlur() {
        this.onChange();
        if (this.options.bigCvv) {
            toggleHelp(this, false);
        }
    },

    appendTo($parent) {
        this.$el.appendTo($parent);
    },

    onFocus() {
        const $paymentRow = this.$paymentRow;
        TextBoxFieldViewProto.onFocus.call(this);
        $paymentRow.removeClass('od-cvv-closed');
        if (this.options.bigCvv) {
            toggleHelp(this, true);
        }
    },

    onInput() {
        setCvvState(this, true);
    },
});
